import { render, staticRenderFns } from "./ChartPolicyViolationBreakdown.vue?vue&type=template&id=118e1147&"
import script from "./ChartPolicyViolationBreakdown.vue?vue&type=script&lang=js&"
export * from "./ChartPolicyViolationBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118e1147')) {
      api.createRecord('118e1147', component.options)
    } else {
      api.reload('118e1147', component.options)
    }
    module.hot.accept("./ChartPolicyViolationBreakdown.vue?vue&type=template&id=118e1147&", function () {
      api.rerender('118e1147', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ChartPolicyViolationBreakdown.vue"
export default component.exports